import { Layout, type LayoutProps } from "./layout";

/**
 * Page — concrete Layout for routed/main-content views. Adds horizontal
 * padding, vertical padding, and a max-width so dense content reads cleanly
 * on wide displays. Compose with Blueprint <Section> children.
 */
export function Page({ children, className, gap, style }: LayoutProps) {
  return (
    <Layout data-testid="page"
      className={["bp-page", className].filter(Boolean).join(" ")}
      gap={gap}
      style={style}
    >
      {children}
    </Layout>
  );
}
